import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API } from '../context/AuthContext';
import { colors, fonts } from '../brand';

export default function SiteFooter() {
  const [contactName, setContactName] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [contactMsg, setContactMsg] = useState('');
  const [contactSent, setContactSent] = useState(false);

  const handleContact = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API}/api/content/contact`, { name: contactName, email: contactEmail, message: contactMsg });
    } catch {}
    setContactSent(true);
    setContactName('');
    setContactEmail('');
    setContactMsg('');
  };

  return (
    <footer style={styles.footer}>
      <div style={styles.footerInner}>

        {/* Column 1 — Email contact */}
        <div style={styles.footerCol}>
          <p style={styles.contactTitle}>Contact Us</p>
          {contactSent ? (
            <p style={styles.contactThanks}>I got your message. You're not alone in this. — Amy</p>
          ) : (
            <form onSubmit={handleContact} style={styles.contactForm}>
              <input id="footer-contact-name" style={styles.contactInput} type="text" placeholder="Your name" value={contactName} onChange={e => setContactName(e.target.value)} required />
              <input style={styles.contactInput} type="email" placeholder="Your email" value={contactEmail} onChange={e => setContactEmail(e.target.value)} required />
              <textarea style={styles.contactTextarea} placeholder="Message" value={contactMsg} onChange={e => setContactMsg(e.target.value)} rows={3} required />
              <button style={styles.contactBtn} type="submit">Send</button>
            </form>
          )}
        </div>

        {/* Column 2 — Brand / nav */}
        <div style={styles.footerCol}>
          <p style={styles.footerName}>Elephants Answering, PBC</p>
          <p style={styles.footerTagline}>Divorce Support &amp; Refuge</p>
          <p style={styles.footerReassurance}>&ldquo;You're not alone in this.&rdquo;</p>

          <p style={styles.followLabel}>FOLLOW @ELEPHANTSANSWERING</p>
          <div style={styles.socialIcons}>
            <a href="https://www.instagram.com/elephantsanswering/" target="_blank" rel="noopener noreferrer" style={styles.socialLink} aria-label="Instagram">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                <circle cx="12" cy="12" r="4"/>
                <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/>
              </svg>
            </a>
            <a href="https://www.tiktok.com/@elephantsanswering" target="_blank" rel="noopener noreferrer" style={styles.socialLink} aria-label="TikTok">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.32 6.32 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.69a8.18 8.18 0 004.78 1.52V6.76a4.85 4.85 0 01-1.01-.07z"/>
              </svg>
            </a>
            <a href="https://www.facebook.com/share/14d1kZ2fRnr/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer" style={styles.socialLink} aria-label="Facebook">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/>
              </svg>
            </a>
          </div>

          <nav style={styles.footerLinks} aria-label="Footer navigation">
            <Link to="/" style={styles.footerLink}>Home</Link>
            <Link to="/about" style={styles.footerLink}>About</Link>
            <Link to="/listen" style={styles.footerLink}>Listen</Link>
            <Link to="/qa" style={styles.footerLink}>Q&amp;A</Link>
            <Link to="/refuge" style={styles.footerLink}>Refuge</Link>
            <Link to="/resources" style={styles.footerLink}>Resources</Link>
            <Link to="/legal-aid" style={styles.footerLink}>Legal Aid</Link>
            <Link to="/quiz" style={styles.footerLink}>Roadmap</Link>
            <Link to="/contact" style={styles.footerLink}>Contact</Link>
            <Link to="/privacy" style={styles.footerLink}>Privacy Policy</Link>
            <Link to="/terms" style={styles.footerLink}>Terms of Service</Link>
            {/* Stripe-hosted customer portal: members enter their email and
                Stripe sends a magic link. Lets them cancel, update a card and
                pull invoices without us building billing UI or auth. */}
            <a
              href="https://billing.stripe.com/p/login/7sYbJ13FE1Ny2yQ6w9cMM00"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.footerLink}
            >
              Manage Subscription
            </a>
          </nav>
          <p style={styles.footerCopy}>© 2026 Elephants Answering, PBC</p>
          <Link to="/login" style={styles.footerSignIn}>Sign In</Link>
        </div>

      </div>
    </footer>
  );
}

const styles = {
  footer: { backgroundColor: colors.navy, color: 'rgba(255,255,255,0.4)', padding: '64px 40px 48px', fontFamily: fonts.body },
  footerInner: { maxWidth: '1000px', margin: '0 auto', display: 'flex', gap: '40px', alignItems: 'flex-start', flexWrap: 'wrap' },
  footerCol: { flex: '1', minWidth: '220px', display: 'flex', flexDirection: 'column', gap: '0' },

  footerName: { color: colors.white, fontFamily: fonts.heading, fontSize: '14px', letterSpacing: '0.5px', marginBottom: '4px' },
  footerTagline: { color: colors.rose, fontSize: '11px', letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '12px' },
  footerReassurance: { color: 'rgba(255,255,255,0.5)', fontFamily: fonts.heading, fontSize: '13px', fontStyle: 'italic', marginBottom: '20px' },
  footerLinks: { display: 'flex', flexDirection: 'column', gap: '6px', marginBottom: '20px' },
  footerLink: { textDecoration: 'none', color: 'rgba(255,255,255,0.5)', fontSize: '12px', fontFamily: fonts.body, letterSpacing: '0.3px' },
  footerCopy: { fontSize: '12px', lineHeight: '1.9', marginBottom: '20px' },
  footerSignIn: { textDecoration: 'none', border: `1px solid ${colors.peach}`, color: colors.peach, padding: '8px 20px', fontSize: '12px', fontFamily: fonts.body, letterSpacing: '0.5px', display: 'inline-block' },

  followLabel: { fontFamily: fonts.body, color: 'rgba(255,255,255,0.4)', fontSize: '10px', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '10px', marginTop: '4px' },
  socialIcons: { display: 'flex', gap: '16px', marginBottom: '24px' },
  socialLink: { color: 'rgba(255,255,255,0.5)', display: 'flex', alignItems: 'center', transition: 'color 0.2s' },

  contactTitle: { fontFamily: fonts.heading, color: colors.white, fontSize: '15px', letterSpacing: '0.5px', marginBottom: '14px', fontWeight: '500' },
  contactForm: { display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '4px' },
  contactInput: { padding: '10px 14px', backgroundColor: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)', color: colors.white, fontSize: '13px', fontFamily: fonts.body, outline: 'none', borderRadius: 0 },
  contactTextarea: { padding: '10px 14px', backgroundColor: 'rgba(255,255,255,0.07)', border: '1px solid rgba(255,255,255,0.15)', color: colors.white, fontSize: '13px', fontFamily: fonts.body, outline: 'none', borderRadius: 0, resize: 'vertical' },
  contactBtn: { padding: '10px 20px', backgroundColor: colors.rose, color: colors.white, border: 'none', fontSize: '13px', fontFamily: fonts.body, fontWeight: '600', cursor: 'pointer', letterSpacing: '0.5px', alignSelf: 'flex-start', borderRadius: 0 },
  contactThanks: { color: colors.peach, fontSize: '13px', fontFamily: fonts.body, fontStyle: 'italic', marginTop: '12px', lineHeight: '1.8' },
};
